import styled from "styled-components";

export const ButtonPrimary = styled.button`
  background-color: ${({ theme }) => theme.colors.primary};
  color: #FFFFFF;
  border-radius: 3px;
  font-weight: 500;
  text-align: center;
  border: 0;
  margin: 0;
  font-size: 14px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.colors.primary}99;
  }
`;

export const ButtonSecondary = styled.button`
  border-radius: 3px;
  color: #CB3D42;
  font-weight: 400;
  text-align: center;
  font-family: Montserrat, sans-serif;
  border: 1px solid #CB3D42;
  width: 144px;
  padding: 11px 0;
  cursor: pointer;
  text-decoration: none;
  background-color: transparent;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }
`

export const LinkPrimary = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 14px;
  padding: 8px;
  cursor: pointer;
  font-weight: ${({ weight }) => weight || 400};
  text-align: ${({ align }) => align || 'left'};
`
